import React, { useState } from 'react';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import { isAllowed } from '../../../../Services/acl.service';
import Tooltip from '../../../../Components/Popup/Tooltip';
import Text from '../../../../Components/Base/Text/Text';
import PatientInsuranceSetupVerifyModal from './PatientInsuranceSetupVerifyModal';
import { useEffectAsync } from '../../../../helpers';
import { useLazyUserNcziProfileQuery } from '../../../../graphql/graphql';

interface Props {
	patientId: string;
}

const PatientVerifyInsuranceButton: React.FC<Props> = ({ patientId }) => {
	const [verifyInsuranceModalOpen, setVerifyInsuranceModalOpen] =
		useState<boolean>(false);
	const [getLazyUserNczi] = useLazyUserNcziProfileQuery();
	const [patientBirthNumber, setPatientBirthNumber] = useState<
		string | undefined
	>(undefined);
	const isNcziEnabled = isAllowed('patient_health_ezdravie');

	const disabledButton = (
		<LinkButton
			title='patientTreatment.profile.verifyInsurance.title'
			theme={Theme.DISABLED}
			onClick={() => {}}
		/>
	);
	const enabledButton = (
		<LinkButton
			title='patientTreatment.profile.verifyInsurance.title'
			theme={Theme.BLUE}
			onClick={() => setVerifyInsuranceModalOpen(true)}
		/>
	);

	useEffectAsync(async () => {
		const { user } = await getLazyUserNczi({
			id: patientId,
		}).unwrap();

		if (user?.profile?.birthNumber) {
			setPatientBirthNumber(user.profile.birthNumber);
		}
	});

	return (
		<>
			{isNcziEnabled ? (
				enabledButton
			) : (
				<>
					<Tooltip
						trigger={disabledButton}
						position='bottom left'
						customStyle={{ width: 'fit-content' }}>
						<Text
							tx={
								patientBirthNumber
									? 'nczi.needSetup'
									: 'appShared.birthNumberMustBeFilled'
							}
						/>
					</Tooltip>
				</>
			)}
			<PatientInsuranceSetupVerifyModal
				opened={verifyInsuranceModalOpen}
				onClose={() => setVerifyInsuranceModalOpen(false)}
				patientId={patientId}
			/>
		</>
	);
};

export default PatientVerifyInsuranceButton;
